
import { Vue, Component } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import DictSelect from '@/components/busi/custom/dictselect.vue'
import util from '@/utils/busi/util'
import { getAgentList, getAgentCount, getUserById, resetPwd, resetOpenId, enableProUser, disableProUser, enableProUserScanStatus, disableProUserScanStatus } from '@/api/agentcenter'
import { getProxyType } from '@/api/common/common'
import Grant from './detail/grant.vue'
import { MessageBox } from 'element-ui'
import { checkPermission } from '@/utils/permission'
import { UserModule } from '@/store/modules/user'
@Component({
  name: 'agent-manage',
  components: {
    SimpleTable,
    Grant,
    DictSelect
  }
})
export default class AgentManage extends Vue {
  private form: any = {
    state: 1,
    scanStatus: -1 // 扫描状态（0：关闭，1：开启）
  }

  get schoolDetailEnable () {
    return !checkPermission(['lbEnOrDis'])
  }

  private loading = !1

  private searchVal = ''

  private grantData: any = {}

  private selectedRow: any[] = []

  private selectionChange (selected: any) {
    this.selectedRow = selected
  }

  private async change (row: any) {
    if (row.state === 1) {
      // 启用
      row.state = 0
      MessageBox.confirm(
        '确认要启用吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
        enableProUser({ id: row.id })
        row.state = 1
      }).catch((e) => {
        console.log(e)
      })
    } else {
      // 禁用
      row.state = 1
      MessageBox.confirm(
        '确认要禁用吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
        disableProUser({ id: row.id })
        row.state = 0
      }).catch((e) => {
        console.log(e)
      })
    }
  }

  private changeScanStatus (row: any) {
    if (row.scanStatus === 1) {
      // 启用
      row.scanStatus = 0
      MessageBox.confirm(
        '确认要启用吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
        enableProUserScanStatus({ id: row.id, scanStatus: 0 })
        row.scanStatus = 1
      }).catch((e) => {
        console.log(e)
      })
    } else {
      // 禁用
      row.scanStatus = 1
      MessageBox.confirm(
        '确认要禁用吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
        disableProUserScanStatus({ id: row.id, scanStatus: 1 })
        row.scanStatus = 0
      }).catch((e) => {
        console.log(e)
      })
    }
  }

  private async onResetPwd () {
    // 重置代码
    if (!this.selectedRow || this.selectedRow.length === 0) {
      this.$alert('请选择账号')
      return
    }
    const ids = this.selectedRow.map((v: any) => v.id)
    const tbsUserIds = this.selectedRow.map((v: any) => v.tbsUserId)
    MessageBox.confirm(
      '提示：是否重置密码为888888', '密码重置', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(async () => {
      await resetPwd({
        tbsUserIds: tbsUserIds.join(','),
        ids: ids.join(',')
      }).then((res: any) => {
        if (res.code === 10000) {
          this.$message(res.message)
        }
      })
    })
  }

  private async onResetOpenId () {
    // 重置openId
    if (!this.selectedRow || this.selectedRow.length !== 1) {
      this.$alert('请选择单个账号')
      return
    }
    await resetOpenId({
      id: this.selectedRow[0].id
    }).then((res: any) => {
      if (res.code === 10000) {
        this.$message(res.message)
      }
    })
  }

  private tableData = {
    list: [],
    totalCount: 2
  }

  private columns = [{
    prop: 'userAccount',
    label: '登录账号',
    format: 'trim'
  },
  {
    prop: 'userName',
    label: '用户名称'
  },
  {
    prop: 'phone',
    label: '手机号'
  },
  {
    prop: 'presenter',
    label: '推荐人',
    format: 'trim'
  },
  {
    prop: 'businessNames',
    label: '业务类型'
  },
  {
    prop: 'proLevelName',
    label: '代理商等级'
  },
  {
    prop: 'applyTime',
    label: '申请时间',
    format: 'date'
  },
  {
    prop: 'settlementMethod',
    label: '结算方式',
    custom: !0
  },
  {
    prop: 'state',
    label: '状态',
    custom: !0
  },
  {
    prop: 'scanStatus',
    label: '扫码状态',
    custom: !0
  }]

  private proTypeData: any = []

  private pagination: any = {
    currentPage: 1,
    pageSize: 10
  }

  private dialogVisible = !1

  private async onQuery (pagination: any = null) {
    this.loading = !0
    const form = util.trimForm({ ...this.form }, ['proType', 'userAccount', 'userName', 'proLevel', 'state', 'scanStatus'])
    const proType = form.proType !== -1 ? form.proType : -1
    form.proType = proType === -1 ? -1 : proType
    !pagination && (this.pagination.currentPage = 1)
    await getAgentList({
      ...form,
      ...pagination || this.pagination
    }).then(async (res: any) => {
      await getAgentCount({
        ...form
      }).then((resCount: any) => {
        this.loading = !1
        this.tableData.list = res.object.list
        this.tableData.totalCount = resCount.object.totalCount
      })
    }).catch((err: any) => {
      console.log('err', err)
      this.loading = !1
    })
  }

  private onReset () {
    this.form = {
      state: 1,
      scanStatus: -1
    }
    this.onQuery()
  }

  // 授权院校弹窗
  private grant (tableData: any) {
    this.grantData = tableData
    this.dialogVisible = !0
  }

  private closeDialog () {
    this.grantData = null
  }

  private async onEdit (row: any) {
    await getUserById({
      id: row.id
    }).then((res: any) => {
      if (res.code === 10000) {
        const proTypes = res.object.lbUserProTypes ? res.object.lbUserProTypes : []
        const proType: any[] = []
        proTypes.map((v: any) => {
          proType.push(v.proType + '-' + v.businessId)
        })
        const obj = res.object
        const params: any = {}
        for (const key in obj) {
          params[key] = (obj[key] === '-1') ? '' : obj[key]
        }
        params.presenterId = params.presenterId ? (params.presenterId + '-' + params.presenter) : null
        this.$router.push({
          name: 'agentdetail',
          params: { ...params, flag: 'edit', proType: proType }
        })
      }
    })
  }

  private async showDetail (row: any) {
    await getUserById({
      id: row.id
    }).then((res: any) => {
      if (res.code === 10000) {
        const proTypes = res.object.lbUserProTypes || null
        const proType: any[] = []
        proTypes && proTypes.map((v: any) => {
          proType.push(v.proType + '-' + v.businessId)
        })
        const params = res.object
        params.proType = proType
        params.presenterId = params.presenterId ? (params.presenterId + '-' + params.presenter) : null
        this.$router.push({
          name: 'agentdetail',
          params: { ...params, flag: 'show', onlyView: !0 }
        })
      }
    })
  }

  private onAdd () {
    this.$router.push({
      name: 'agentdetail',
      params: { deadline: (new Date().getTime() + 315360000 * 1000) + '', scanStatus: 0 + '', state: 1 + '' }
    })
  }

  private async initData () {
    await getProxyType({}).then((res: any) => {
      if (res.code === 10000) {
        this.proTypeData = [res.object.rpcOptions]
      }
    })
  }

  beforeMount () {
    this.initData()
  }

  get userId () {
    return UserModule.id
  }

  mounted () {
    // 留学中心办账号登录显示“状态”，否则不显示
    console.log('userId:', this.userId)
    if (this.userId !== '890') {
      this.columns.splice(this.columns.length - 1, 1)
    }
    this.onQuery()
  }
}
